import http from "@/utils/axios";
import { notify } from "@kyvg/vue3-notification";

export default {
  namespaced: true,
  state: {
    patients: [],
    errors: [],
    pagination: {
      currentPage: 1,
      total: 1,
    },
    search: "",
    currentPatient: {
      first_name: "",
      last_name: "",
      phone_number: "",
      identity_card: "",
      pesel: "",
      birth_date: "",
      day: "",
      month: "",
      year: "",
      gender: "",
    },
  },
  getters: {
    getPatients: (state) => state.patients,
    getErrors: (state) => state.errors,
    getPagination: (state) => state.pagination,
  },
  mutations: {
    setErrors(state, errors) {
      state.errors = errors;
    },
    clearErrors(state) {
      state.errors = [];
    },
    setSearch(state, search) {
      state.search = search;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
    updatePatient(state, user) {
      const index = state.patients.findIndex(
        (patient) => patient.id === user.id
      );
      state.patients[index] = user;
    },
    clearSearch(state) {
      state.search = "";
    },
    clearPatients(state) {
      state.patients = [];
      state.pagination.currentPage = 1;
      state.pagination.total = 1;
    },
  },
  actions: {
    async updateChild({ commit }, child) {
      await http
        .put(`/profile/update-child/${child.id}`, child)
        .then(() => {
          commit("clearErrors");
          notify({
            type: "success",
            text: "messages.edit.success",
            duration: 5000,
          });
        })
        .catch(({ response }) => {
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
          }
          if (response && response.status === 403) {
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
            return;
          }
          notify({
            type: "danger",
            text: "messages.edit.failure",
            duration: 5000,
          });
        });
    },
    async updatePatient({ commit, state }, referralId = null) {
      await http
        .put(
          referralId
            ? `/referrals/update-patient/${state.currentPatient.id}/${referralId}`
            : `/doctor/patients/update/${state.currentPatient.id}`,
          state.currentPatient
        )
        .then(({ data }) => {
          commit("clearErrors");
          if (referralId)
            commit("referrals/setCurrentReferralPatient", data.user, {
              root: true,
            });
          else commit("updatePatient", data.user);
          notify({
            type: "success",
            text: "messages.edit.success",
            duration: 5000,
          });
          commit("modals/closeModal", "createPatient", { root: true });
        })
        .catch(({ response }) => {
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
          }
          if (response && response.status === 403) {
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
            return;
          }
          notify({
            type: "danger",
            text: "messages.edit.failure",
            duration: 5000,
          });
        });
    },
  },
};
